import moment from "moment-timezone";

// Business Manager's Job History format, in the SFCC instance's time zone.
export const formatReindexTime = (iso: string, timeZone: string): string =>
  iso
    ? `${moment.tz(iso, timeZone).format("M/D/YY h:mm:ss a")} (${timeZone})`
    : "";
